import { Carousel } from 'react-responsive-carousel';

import logo2MIN from '../assets/mb_login_image_2_min.jpg';
import logo3MIN from '../assets/mb_login_image_3_min.jpg';

export const CarouselBg = () => {
    const items =  [
        { img: logo2MIN },
        { img: logo3MIN }
      ]
    return (
      <Carousel
        autoPlay={true}
        interval={5000}
        showIndicators={true}
        showArrows={true}
        transitionTime={2000}
        infiniteLoop={true}
        autoFocus={false}
        showThumbs={false}
        stopOnHover={false}
      >
        {
         items.map((item, i) => (
            <div key={i} className="flex justify-center w-full">
              <img className="rounded w-full" src={item.img} alt="logo of provider"></img>
            </div>
          ))
        }
      </Carousel>
    )
}
